// extracted by mini-css-extract-plugin
export default {"container":"_datagrid__container","validation":"_datagrid__validation"};